/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi Framework
 * Kiwi API description
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChunkDeleteRequest
 */
export interface ChunkDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof ChunkDeleteRequest
     */
    documentId: string;
    /**
     * 
     * @type {string}
     * @memberof ChunkDeleteRequest
     */
    chunkId: string;
}

/**
 * Check if a given object implements the ChunkDeleteRequest interface.
 */
export function instanceOfChunkDeleteRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "documentId" in value;
    isInstance = isInstance && "chunkId" in value;

    return isInstance;
}

export function ChunkDeleteRequestFromJSON(json: any): ChunkDeleteRequest {
    return ChunkDeleteRequestFromJSONTyped(json, false);
}

export function ChunkDeleteRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChunkDeleteRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'documentId': json['documentId'],
        'chunkId': json['chunkId'],
    };
}

export function ChunkDeleteRequestToJSON(value?: ChunkDeleteRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'documentId': value.documentId,
        'chunkId': value.chunkId,
    };
}

